export default __webpack_public_path__ + "static/media/birthday-bonus-ico.389b2931.svg";